import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Select, Tabs, Button, Collapse, message } from 'antd';
import { WaterMark } from '@ant-design/pro-layout';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Drawer from '../../components/Drawer';
import { addClass, getPermissionById } from '../../utils';
import { PermissionButton, CockpitMode, IssueType } from '../../utils/constant';
import './index.scss';
import WorkOrderDrawer from './components/WorkOrderDrawer';
import { useTextToSpeech } from '@/utils/hooks';
import RenderBottomBtn from './components/WorkOrderDrawer/RenderBottomBtn';
import classNames from 'classnames';
import IssueApi from '@/fetch/bussiness/issue';
import { enumTranslator } from '@/utils';
import { HttpStatusCode } from '@/fetch/core/constant';
const { TabPane } = Tabs;
const { Panel } = Collapse;

const MainLayout = () => {
  const fetchApi = new IssueApi();
  const pathname = window.location.pathname;
  const speechRef = useRef<any>(null);
  const [waterMark, setWaterMark] = useState('');
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showDrawer, setShowDrawer] = useState(true);
  const login = useSelector((state: any) => state.login);
  const { issueList } = useSelector((state: any) => state.workOrder);
  const newIssueList: any[] = [];
  const reminderIssueList = [];
  for (let val of issueList) {
    if (val.newIssue) {
      newIssueList.push(val);
    }
    if (val.issueReminder) {
      reminderIssueList.push(val.issueNumber);
    }
  }
  const { cockpitMode, cockpitTeamNumber, currentCockpit } = useSelector(
    (state: any) => state.cockpitInfo,
  );
  const controlPermission = getPermissionById(PermissionButton.SPV_ISSUE_VIEW);

  useTextToSpeech(
    '您有新的工单啦',
    newIssueList && newIssueList?.length > 0
      ? newIssueList[0]?.issueNumber
      : null,
  );

  useEffect(() => {
    if (cockpitMode && cockpitMode === CockpitMode.PATROL_MODE) {
      setShowDrawer(false);
    } else {
      setShowDrawer(true);
    }
  }, [cockpitMode]);

  useEffect(() => {
    if (login.user && login.user.username) {
      setWaterMark(login.user.username);
    }
  }, [login.user && login.user.username]);

  useEffect(() => {
    addClass();
  }, []);

  useEffect(() => {
    if (reminderIssueList.length > 0 && !isDrawerOpen) {
      setIsDrawerOpen(true);
    }
  }, [JSON.stringify(reminderIssueList)]);

  const collapseNode = (
    <>
      {controlPermission && (
        <div className='work-order-icon icon-box'>
          <i className='work-order'></i>
          <i
            className={classNames('alarm-num', {
              showRedIcon: issueList?.length > 0,
            })}
          >
            {issueList?.length}
          </i>
          工单
        </div>
      )}
    </>
  );

  const hasAlarmComp =
    getPermissionById(PermissionButton.SPV_ALARM_DRAWER) &&
    cockpitMode !== CockpitMode.MONITOR;

  const cancelNewIssue = (cb?: any) => {
    newIssueList?.length > 0 &&
      fetchApi
        .cancelNewIssue(
          newIssueList.map((v: any) => v.issueNumber),
          currentCockpit.cockpitNumber,
        )
        .then((res) => {
          if (res.code !== HttpStatusCode.Success) {
            message.error(res.message);
          }
        })
        .finally(() => {
          cb && cb();
        });
  };

  const handelExpandDrawer = (isOpen: boolean) => {
    cancelNewIssue(setIsDrawerOpen(isOpen));
  };
  const handleCollapse = (isOpen: boolean) => {
    cancelNewIssue(setIsDrawerOpen(isOpen));
  };

  return (
    <WaterMark
      content={waterMark}
      fontColor='rgba(255,255,255,.15)'
      className='jd-warter-mark'
    >
      <div className='layout'>
        <Header />
        <div className='main-content'>
          <Outlet />
        </div>
        {hasAlarmComp && showDrawer && (
          <Drawer
            key={location.pathname}
            defaultOpened={isDrawerOpen}
            width={388}
            direction={'left'}
            collapseNode={collapseNode}
            classNames='right-flow-box'
            btnWrapperCls='flow-suspended-btn'
            handleCollapse={() => handleCollapse(false)}
            handleExpand={() => handelExpandDrawer(true)}
          >
            <WorkOrderDrawer isDrawerOpen={isDrawerOpen} />
          </Drawer>
        )}
      </div>
      {!isDrawerOpen &&
        newIssueList?.length > 0 &&
        newIssueList?.map((item: any, index: number) => {
          return (
            <div
              key={item.vehicleName}
              className={classNames('message-card', {
                first: index === 0,
                second: index === 1,
              })}
            >
              <img
                className='icon'
                src={
                  item.emergencyIssue
                    ? require('../../assets/img/cockpit/msg_card_urgent.png')
                    : require('../../assets/img/cockpit/msg_card_not_urgent.png')
                }
              ></img>
              <p className='title'>
                {item.emergencyIssue
                  ? '紧急工单，建议优先受理！'
                  : '您有新的工单，请及时处理!'}
              </p>
              <p className='msg-content'>
                <>{item.vehicleName}</>
                {item.issueEventList
                  ? `${
                      '出现' +
                      item.issueEventList
                        .map((v: any) =>
                          enumTranslator('ALARM_EVENT_ENUM', v.eventType),
                        )
                        .join('、') +
                      '事件'
                    }`
                  : ''}
              </p>
              <div className='bottom-handle-btns'>
                <RenderBottomBtn issueInfo={item} isNotification={true} />
              </div>
            </div>
          );
        })}
    </WaterMark>
  );
};

export default React.memo(MainLayout);
